<template>
    <div>
        <app-filters 
            :types="types"
            :searchMails="onFilter"
            :cancelFilter="cancelFilter"
        />
        <b-alert variant="success" v-if="!mails.length" show>¡No hay datos!</b-alert>
        <app-delivered-mail-table v-if="mails.length"
            :mails="mails"
            :view-mail="seeMore"
        />
        <div class="d-flex flex-column align-items-center" v-if="mails.length">
            <app-paginator 
                :current-page="data.current_page"
                :last-page="data.last_page"
                :from="data.from"
                :to="data.to"
                :per-page="data.per_page"
                :total="data.total"
                :onChangePage="onChangeMailsDelivered"
            />
        </div>
    </div>
</template>

<script>
import DeliveredMailTable from '../../../Vigilance/Mail/MailPage/DeliveredMail/DeliveredMailTable/DeliveredMailTable.vue';
import DeliveredMailFilters from '../../../Vigilance/Mail/MailPage/DeliveredMail/DeliveredMailFilters/DeliveredMailFilters.vue';
import Paginator from '../../../UI/Controls/Paginator/Paginator.vue';
export default {
    components: {
        appDeliveredMailTable: DeliveredMailTable,
        appPaginator: Paginator,
        appFilters: DeliveredMailFilters
    },
    props: {
        data: {
            type: Object
        },
        seeMore: {
            type: Function
        },
        types: {
            type: Array,
        },
        onChangeMailsDelivered: {
            type: Function
        },
        onFilter: {
            type: Function
        },
        cancelFilter: {
            type: Function
        }

    },
    data(){
        return{
            mails: []
        }
    },
    watch: {
       data(val){
           this.mails = this.data.data;
       } 
    }
}
</script>
